import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  template: `
    <div *ngFor="let action of actions">
      <button mat-raised-button color="primary" (click)="action.execute(data)" [disabled]="action.canExecute && !(action.canExecute(data))">{{(action.statusField && data[action.statusField]) || data[action.titleField]}}</button>
    </div>
  `
})
export class ActionsCellComponent implements ICellRendererAngularComp {

  data: any;
  actions?: any[];

  constructor() {}

  agInit(params: any): void {
    this.data = params.data;
    this.actions = params.actions;
  }

  refresh(): boolean {
    return false;
  }
}
